export const subCategoryReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_SUB_CATEGORY_LIST_REQUEST": {
      return {
        ...state,
        loading: true,
        subCategories: null,
      };
    }
    case "GET_SUB_CATEGORY_LIST_SUCCESS": {
      return {
        ...state,
        loading: false,
        subCategories: action.payload,
      };
    }
    case "GET_SUB_CATEGORY_LIST_FAILED": {
      return {
        ...state,
        loading: false,
        subCategories: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
